// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Contact","App__Main":"App__Main"};